import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bySubdomain: {},
};

const portalContextSlice = createSlice({
  name: "portalContext",
  initialState,
  reducers: {
    setPortalResolved: (state, action) => {
      const { subdomain, data } = action.payload;
      state.bySubdomain[subdomain] = {
        portalId: data.id,
        subdomain: data.subdomain,
        name: data.name,
        catalogTitle: data.catalog_title,
        primaryColor: data.primary_color,
        logo: data.logo,
        isActive: data.is_active,
        ...data,
      };
    },
    setPortalResolveFailed: (state, action) => {
      const { subdomain, error } = action.payload;
      state.bySubdomain[subdomain] = {
        error,
        status: "failed",
      };
    },
    clearPortalContext: (state, action) => {
      const subdomain = action.payload;
      delete state.bySubdomain[subdomain];
    },
  },
});

export const { setPortalResolved, setPortalResolveFailed, clearPortalContext } = portalContextSlice.actions;

export const selectPortalContext = (state, subdomain) => state.portalContext.bySubdomain[subdomain];
export const selectPortalId = (state, subdomain) => state.portalContext.bySubdomain[subdomain]?.portalId;

export default portalContextSlice.reducer;
